import React, { Component } from 'react';
import Header from './Header';
import Body from './Body';
import BodyHeader from './BodyHeader';
import BodyContent from './BodyContent';
import GreyButton from './GreyButton';
import OrangeButton from './OrangeButton';
import Footer from './Footer';
import './styles.css';

class ResultsDocumentLayout extends Component {
	render() {
		return <div className="results-document-layout">{this.props.children}</div>;
	}
}

Object.assign(ResultsDocumentLayout, {
	Header,
	Body,
	Footer,
	BodyHeader,
	BodyContent,
	GreyButton,
	OrangeButton
});

export default ResultsDocumentLayout;
